module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tracking-list"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-12 column"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('order.label.item.tracking-label')))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-5 medium-3 large-2 column"
  }, [_vm._v(_vm._s(_vm.$t('order.label.item.tracking.shipped-qty')))]), _vm._v(" "), _c('div', {
    staticClass: "small-7 medium-9 large-10 column"
  }, [_c('strong', [_vm._v(_vm._s(_vm.articleShippedQty))])])]), _vm._v(" "), (!_vm.hasTrackingItems) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-12 column"
  }, [(!_vm.trackingItemsIsDefined) ? _c('p', [_vm._v(_vm._s(_vm.$t('order.label.item.tracking.not-available')))]) : _c('p', [_vm._v(_vm._s(_vm.$t('order.label.item.tracking.parcel-tracking-nolink')))])])]) : _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-4 medium-3 large-2 column number"
  }, [_vm._v(_vm._s(_vm.$t('order.label.item.tracking.parcel-number')))]), _vm._v(" "), _c('div', {
    staticClass: "small-7 medium-9 large-10 small-offset-1 medium-offset-0 column"
  }, [_vm._v(_vm._s(_vm.$t('order.label.item.tracking.parcel-tracking-url')))])]), _vm._v(" "), _vm._l((_vm.trackingItems), function(trackingItem) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "small-4 medium-3 large-2 column number"
    }, [_c('strong', [_vm._v(_vm._s(trackingItem.number))])]), _vm._v(" "), _c('div', {
      staticClass: "small-7 medium-9 large-10 small-offset-1 medium-offset-0 column"
    }, [_c('delivery-chips', {
      staticClass: "no-margin",
      attrs: {
        "link": trackingItem.link
      }
    })], 1)])
  })], 2), _vm._v(" "), (_vm.articleOrderedQty != _vm.articleShippedQty) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-5 medium-3 large-2 column"
  }, [_vm._v(_vm._s(_vm.$t('order.label.item.remaining-qty')))]), _vm._v(" "), _c('div', {
    staticClass: "small-7 medium-9 large-10 column"
  }, [_c('strong', [_vm._v(_vm._s(_vm.articleOrderedQty - _vm.articleShippedQty))])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-30720dc0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TrackingList.vue
// module id = 294
// module chunks = 2